import { dfEvents } from './events';
import { dfProfessions } from './professions';

export const dfTasks = [dfEvents, dfProfessions];
